import React, { useState } from 'react';
import {
  ChakraProvider,
  Box,
  VStack,
  HStack,
  Text,
  Heading,
  Button,
  Container,
  Flex,
  Link,
  IconButton,
  useColorMode,
  Stack,
  useDisclosure,
  SimpleGrid,
  Image,
  Card,
  CardBody,
  Badge,
  AspectRatio,
  Divider,
  Icon,
  List,
  ListItem,
  ListIcon,
  Avatar,
  For
} from '@chakra-ui/react';

import { GrFormView } from 'react-icons/gr';
import { FaExternalLinkAlt, FaFacebook, FaYoutube } from 'react-icons/fa';
import { SiMinutemailer } from 'react-icons/si';
import { FcPhoneAndroid } from 'react-icons/fc';
import { IoCall, IoLocation } from 'react-icons/io5';
import ViewPhotosSwiper from './view-photos-swiper';
import IframeEmbed from './iframe-embed';
import { useParams } from 'react-router-dom';

import { useColorModeValue } from './chakra-ui/color-mode';

function CustomerEvent({ allEvents, eventData: directEventData }) {
  const { eventId } = useParams();
  const eventData = directEventData || (allEvents && allEvents[eventId]);

  const bgColor = useColorModeValue('gray.50', 'gray.950');
  const bgColor2 = useColorModeValue('gray.50', 'black');
  const borderColor = useColorModeValue('gray.200', 'gray.800');
  const year = new Date().getFullYear();

  if (!eventData)
    return (
      <Box
        p={4}
        m={0}
        textAlign="center"
        w="full"
        h="500px"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        No Event Found
      </Box>
    );

  return (
    <Container p={4}>
      {/* Title */}
      <Heading size="4xl" textAlign="center" mb={8}>
        {eventData.title}
      </Heading>



      {/* Photos Section */}
      {eventData.photos.length > 0 && (
        <Box
          w="100%"
          rounded="xl"
          shadow="md"
          mb={4}
          bg={bgColor}
        >
          <ViewPhotosSwiper
            photos={eventData.photos}
            selectedIndex={0}
            autoPlay={true}
          />
        </Box>
      )}

      {/* YouTube Videos Section */}
      {eventData.youtubeDetails.length > 0 && (
        <Box>
          {eventData.youtubeDetails.map((video, idx) => (
            <Box mb={4} shadow="md" p={2} rounded="md" bg={bgColor} key={idx}>
              <Box w="100%" p={2} mb={2} rounded="2xl">
                <Heading size="lg">{video.name}</Heading>
                <Text fontSize="md" color="gray.600">
                  📅 {video.date}
                </Text>
                <Text fontSize="md" color="gray.600">
                  📍 {video.location}
                </Text>
              </Box>

              <AspectRatio ratio={16 / 9} h={{ base: '100%', md: '500px' }}>
                <iframe
                  src={`https://www.youtube.com/embed/${video.youtubeId}`}
                  title={video.name || `YouTube video ${idx + 1}`}
                  allowFullScreen
                  style={{
                    borderTopLeftRadius: '8px',
                    borderTopRightRadius: '8px'
                  }}
                />
              </AspectRatio>
            </Box>
          ))}
        </Box>
      )}

      {/* Embedded iframes Section */}
      {eventData.iframes && eventData.iframes.length > 0 && (
        <Box>
          {eventData.iframes.map((embed, idx) => (
            <IframeEmbed key={idx} embed={embed} />
          ))}
        </Box>
      )}
    </Container>
  );
}
export default CustomerEvent;
